/**
 * imageOverlayStore.js — In-app Image Lightbox & Preview Overlay.
 *
 * Provides a clean modal viewer for clicked images in chat, markdown,
 * and charts with zoom, pan, copy, and download options.
 */

import { createSignal } from 'solid-js';

const [activeImage, setActiveImage] = createSignal(null); // { url, alt, caption }

export const imageOverlay = {
  active: () => activeImage(),
  open(url, alt = '', caption = '') {
    if (!url) return;
    setActiveImage({ url, alt, caption });
  },
  close() {
    setActiveImage(null);
  },
};

export function openImageOverlay(url, alt = '', caption = '') {
  imageOverlay.open(url, alt, caption);
}
